var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7556 0.82666H11.5108C5.61875 0.82666 0.827148 5.61826 0.827148 11.5103V34.6581C0.827148 35.1304 1.01475 35.5833 1.34867 35.9172C1.6826 36.2511 2.13551 36.4387 2.60775 36.4387H25.7556C31.6476 36.4387 36.4392 31.6471 36.4392 25.7551V11.5103C36.4392 5.61826 31.6476 0.82666 25.7556 0.82666ZM13.2896 27.5357H9.73016V23.9763L19.5769 14.1438L23.1363 17.7032L13.2896 27.5357ZM24.8154 16.0241L21.256 12.4647L23.9696 9.75282L27.5291 13.3122L24.8154 16.0241Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit-btn.57f6e3cd604922529b78fe7ae92d67aa.svg";
export { ForwardRef as ReactComponent };